import React from "react"
import useProgressiveImg from "./ProgressiveImage"

const LazyImage = props => {
  const [src, { blur }] = useProgressiveImg(props.lowRes, props.highRes)
  return (
    <img
      alt={props.alt}
      src={src}
      style={{
        filter: blur ? "blur(20px)" : "none",
        transition: blur ? "none" : "filter 0.3s ease-out",
      }}
      {...props}
    />
  )
}

export default LazyImage
